import React from 'react';
import { Content, Row, Col, Title, Text } from 'components';
import { SideMenu } from '../components';
import { Input, Checkbox, Spin, Button } from 'antd';
import { openAddressModal } from 'utils/DaumAPIManager';

const MypageEditProfilePresenter = (props) => {
  /* ===== Props ===== */
  const {
    user,
    inputValue,
    onChange,
    navigate,
    checkedList,
    checkListItem,
    onChecked,
    isLoading,
    onOpenAuthPopup,
    authCode,
    timeText,
    authStatus,
    inputAuthCode,
    onSendAuthCode,
    onAuthCode,
    setInputAuthCode,
    onSubmit,
    screenSize,
  } = props;

  const [isUpdate, setIsUpdate] = React.useState(false);

  /* ===== Variables ===== */

  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },
    label: {
      fontWeight: 'bold',
      marginBottom: 8,
    },
    required: {
      color: 'red',
    },
    message: {
      color: 'red',
      marginTop: 8,
    },
    input: {
      width: '100%',
      height: screenSize >= 768 ? 44 : 38,
      //height: 44,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '180%',
      borderRadius: '2px',
    },
    checkbox: {
      fontSize: screenSize >= 768 ? 16 : 14,
      //fontSize: 18,
      fontWeight: 400,
      color: 'var(--dark-gray-color)',
    },
  };

  const formItems = [
    !inputValue?.social_id && {
      label: '아이디',
      required: true,
      form: [
        {
          key: 'user_account',
          input: (
            <Input
              value={inputValue?.user_account}
              disabled
              style={{
                ...styles.input,
              }}
            />
          ),
          x: 19,
          md: 12,
        },
      ],
    },
    !inputValue?.social_id && {
      label: '비밀번호',
      required: true,
      form: [
        {
          key: 'password',
          input: (
            <Input.Password
              value={inputValue.password}
              placeholder="비밀번호를 입력해주세요."
              style={{
                ...styles.input,
              }}
              onChange={(e) => onChange('password', e.target.value)}
            />
          ),
          x: 19,
          md: 12,
        },
      ],
    },
    !inputValue?.social_id && {
      label: '비밀번호 확인',
      required: true,
      form: [
        {
          key: 'password',
          input: (
            <Input.Password
              value={inputValue.re_password}
              placeholder="비밀번호를 한번 더 입력해주세요."
              style={{
                ...styles.input,
              }}
              onChange={(e) => onChange('re_password', e.target.value)}
            />
          ),
          x: 19,
          md: 12,
        },
      ],
    },
    {
      label: '이름',
      required: true,
      form: [
        {
          key: 'user_name',
          input: (
            <Input
              value={inputValue?.user_name}
              disabled
              style={{
                ...styles.input,
              }}
            />
          ),
          x: 19,
          md: 12,
        },
      ],
    },
    user?.user_email
      ? {
          label: '이메일',
          required: true,
          form: [
            {
              key: 'user_email',
              input: (
                <Input
                  value={user?.user_email}
                  placeholder="이메일을 입력해주세요."
                  disabled
                  style={{
                    ...styles.input,
                  }}
                />
              ),
              x: 19,
              md: 12,
            },
            {
              input: (
                <Button
                  type="primary"
                  style={{ width: '100%', borderRadius: '2px', height: '96%' }}
                  onClick={() => {
                    setIsUpdate(!isUpdate);
                    onChange('user_email', '');
                  }}
                >
                  변경
                </Button>
              ),
              x: 5,
              md: 3,
            },
            ...(isUpdate
              ? [
                  {
                    key: 'user_email',
                    input: (
                      <Input
                        value={inputValue?.user_email}
                        placeholder="이메일을 입력해주세요."
                        style={{
                          ...styles.input,
                          marginTop: 10,
                        }}
                        onChange={(e) => onChange('user_email', e.target.value)}
                        disabled={!!authCode}
                      />
                    ),
                    x: 19,
                    md: 12,
                  },
                  {
                    input: (
                      <Button
                        type="primary"
                        style={{
                          width: '100%',
                          borderRadius: '2px',
                          height: 44,
                          marginTop: 10,
                        }}
                        onClick={() => onSendAuthCode()}
                        disabled={authStatus === 'success'}
                      >
                        {authCode
                          ? authStatus !== 'success'
                            ? '재전송'
                            : '인증완료'
                          : '이메일인증'}
                      </Button>
                    ),
                    x: 5,
                    md: 3,
                  },
                  ...(authCode
                    ? [
                        {
                          key: 'inputAuthCode',
                          input: (
                            <Input
                              value={inputAuthCode}
                              onChange={(e) => setInputAuthCode(e.target.value)}
                              placeholder={`인증번호 6자리를 입력해 주세요.`}
                              style={{ ...styles.input, marginTop: 10 }}
                              disabled={authStatus === 'success'}
                              maxLength={6}
                              suffix={
                                <p
                                  style={{
                                    color: 'var(--danger-color)',
                                  }}
                                >
                                  {timeText}
                                </p>
                              }
                            />
                          ),
                          x: 19,
                          md: 12,
                        },
                        {
                          input: (
                            <Button
                              type="primary"
                              style={{
                                width: '100%',
                                borderRadius: '2px',
                                marginTop: 10,
                                height: 44,
                              }}
                              onClick={onAuthCode}
                              disabled={authStatus === 'success'}
                            >
                              {authStatus === 'success' ? '인증완료' : '확인'}
                            </Button>
                          ),
                          x: 3,
                        },
                      ]
                    : []),
                ]
              : []),
          ],
        }
      : {
          label: '이메일',
          required: true,
          form: [
            {
              key: 'user_email',
              input: (
                <Input
                  value={inputValue?.user_email}
                  placeholder="이메일을 입력해주세요."
                  style={{
                    ...styles.input,
                  }}
                  onChange={(e) => onChange('user_email', e.target.value)}
                  disabled={!!authCode}
                />
              ),
              x: 19,
              md: 12,
            },
            {
              input: (
                <Button
                  type="primary"
                  style={{ width: '100%', borderRadius: '2px', height: 44 }}
                  onClick={() => onSendAuthCode()}
                  disabled={authStatus === 'success'}
                >
                  {authCode
                    ? authStatus !== 'success'
                      ? '재전송'
                      : '인증완료'
                    : '이메일인증'}
                </Button>
              ),
              x: 5,
              md: 3,
            },
            ...(authCode
              ? [
                  {
                    key: 'inputAuthCode',
                    input: (
                      <Input
                        value={inputAuthCode}
                        onChange={(e) => setInputAuthCode(e.target.value)}
                        placeholder={`인증번호 6자리를 입력해 주세요.`}
                        style={{ ...styles.input, marginTop: 10 }}
                        disabled={authStatus === 'success'}
                        maxLength={6}
                        suffix={
                          <p
                            style={{
                              color: 'var(--danger-color)',
                            }}
                          >
                            {timeText}
                          </p>
                        }
                      />
                    ),
                    x: 19,
                    md: 12,
                  },
                  {
                    input: (
                      <Button
                        type="primary"
                        style={{
                          width: '100%',
                          borderRadius: '2px',
                          marginTop: 10,
                          height: 44,
                        }}
                        onClick={onAuthCode}
                        disabled={authStatus === 'success'}
                      >
                        {authStatus === 'success' ? '인증완료' : '확인'}
                      </Button>
                    ),
                    x: 5,
                    md: 3,
                  },
                ]
              : []),
          ],
        },
    {
      label: '휴대폰 번호',
      required: true,
      form: [
        {
          key: 'user_phone',
          input: (
            <Input
              value={inputValue?.user_phone}
              placeholder="번호를 입력해주세요."
              disabled
              style={{
                ...styles.input,
              }}
              onChange={(e) => onChange('user_phone', e.target.value)}
            />
          ),
          x: 19,
          md: 12,
        },
        {
          input: (
            <Button
              type="primary"
              style={{ width: '100%', borderRadius: '2px', height: '96%' }}
              onClick={() => onOpenAuthPopup()}
            >
              변경
            </Button>
          ),
          x: 5,
          md: 3,
        },
      ],
    },
    {
      label: '주소',
      form: [
        // 우편번호와 주소 찾기 버튼 (가로 정렬)
        {
          input: (
            <Row
              gutter={16}
              style={{ width: screenSize >= 768 ? '64%' : '80%' }}
            >
              <Col x={17} style={{ padding: '0 8px 0 0' }}>
                <Input
                  value={inputValue?.postcode}
                  placeholder="우편번호"
                  style={{ ...styles.input }}
                  readOnly
                />
              </Col>
              <Col x={7}>
                <Button
                  type="primary"
                  style={{ width: '95%', borderRadius: '2px', height: '96%' }}
                  onClick={() => handleAddressModal()}
                >
                  변경
                </Button>
              </Col>
            </Row>
          ),
          x: 24, // 전체 너비 사용
        },
        {
          key: 'user_address',
          input: (
            <Input
              value={inputValue.user_address}
              placeholder="기본주소"
              style={{ ...styles.input, marginTop: 8 }}
              readOnly
            />
          ),
          x: 20,
          md: 12,
        },
        {
          key: 'user_address_detail',
          input: (
            <Input
              value={inputValue.user_address_detail}
              placeholder="나머지 주소"
              style={{ ...styles.input, marginTop: 8 }}
              onChange={(e) => onChange('user_address_detail', e.target.value)}
            />
          ),
          x: 20,
          md: 12,
        },
        {
          key: 'address_info',
          input: (
            <Text
              style={{
                fontSize: 14,
                color: '#f61515ff',
              }}
            >
              * 상세주소가 없을 시 건물명 또는 층수를 입력해주세요.
            </Text>
          ),
        },
      ],
    },
    {
      label: '성별',
      form: [
        {
          key: 'user_gender',
          input: (
            <Input
              value={inputValue?.user_gender === 'M' ? '남자' : '여자'}
              disabled
              style={{
                ...styles.input,
              }}
            />
          ),
          x: 20,
          md: 12,
        },
      ],
    },
    {
      label: '생년월일',
      form: [
        {
          key: 'year',
          input: (
            <Input
              value={inputValue.year}
              onChange={(e) => onChange('year', e.target.value)}
              placeholder="년도"
              style={{ ...styles.input }}
              readOnly
              disabled
              suffix={'년'}
            />
          ),
          x: 10,
          mx: 6,
        },
        {
          key: 'month',
          input: (
            <Input
              value={inputValue.month}
              onChange={(e) => onChange('month', e.target.value)}
              placeholder="월"
              style={{ ...styles.input }}
              readOnly
              disabled
              suffix={'월'}
            />
          ),
          x: 7,
          md: 3,
        },
        {
          key: 'day',
          input: (
            <Input
              value={inputValue.day}
              onChange={(e) => onChange('day', e.target.value)}
              placeholder="일"
              style={{ ...styles.input }}
              readOnly
              disabled
              suffix={'일'}
            />
          ),
          x: 7,
          md: 3,
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /**
   * 다음 주소 API
   * --
   */
  const handleAddressModal = () => {
    openAddressModal((res) => {
      const { address, zonecode } = res;

      onChange('user_address', address);
      onChange('postcode', zonecode);
      onChange('user_address_detail', '');
    });
  };

  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                      ? '0 0 0 20px'
                      : '0'
                }
              >
                <div style={{ ...styles.titleLayout }}>
                  <Title
                    style={{
                      ...styles.title,
                    }}
                  >
                    회원 정보 수정
                  </Title>
                </div>

                <Content maxWidth={'100%'} padding={'40px 0px 60px'}>
                  {formItems.map((_item, _index) =>
                    !_item ? null : (
                      <Row
                        gutter={[16]}
                        key={`form_item_${_index}`}
                        direction={
                          _item.label === '주소' ? 'vertical' : 'horizontal'
                        }
                      >
                        <Col x={24}>
                          <p style={styles.label}>{_item.label}</p>
                        </Col>
                        <Col x={24} style={{ padding: 0 }}>
                          <Row
                            gutter={16}
                            style={{
                              marginBottom: 24,
                              flexDirection:
                                _item.label === '주소' ? 'column' : 'row',
                            }}
                          >
                            {_item.form?.map((_subitem, _subindex) => (
                              <Col
                                x={_subitem.x ?? 24}
                                key={`input_${_index}_${_subindex}`}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    width: '100%',
                                    height: '100%',
                                  }}
                                >
                                  {_subitem.input}
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                    ),
                  )}
                </Content>

                {/* 약관동의 */}
                <Content
                  maxWidth={'100%'}
                  padding={'32px 0px'}
                  style={{
                    borderTop: '1px solid var(--light-gray-color)',
                    borderBottom: '1px solid var(--light-gray-color)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                  }}
                >
                  {checkListItem.map((_item) => (
                    <Checkbox
                      key={`checked-${_item.key}`}
                      style={{ ...styles.checkbox }}
                      checked={checkedList[_item.key]}
                      onChange={(e) => onChecked(_item.key, e.target.checked)}
                    >
                      {_item.label}
                    </Checkbox>
                  ))}
                  {/* <Checkbox style={{ ...styles.checkbox }}>
                혜택 및 광고성 정보 수신 동의 (선택)
              </Checkbox> */}
                </Content>
                {/* 약관동의 끝 */}

                <Content
                  maxWidth={'100%'}
                  padding={'32px 0px'}
                  style={{
                    display: 'flex',
                    justifyContent: 'end',
                  }}
                >
                  <Text
                    style={{
                      width: 'fit-content',
                      borderBottom: '1px solid var(--black-color)',
                      cursor: 'pointer',
                      fontSize: screenSize >= 768 ? 15 : 14,
                    }}
                    onClick={() => navigate('/withdraw')}
                  >
                    회원탈퇴
                  </Text>
                </Content>

                <Content
                  maxWidth={'100%'}
                  padding={0}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: screenSize >= 768 ? 24 : 20,
                    marginTop: screenSize >= 768 ? 100 : 20,
                  }}
                >
                  <Button
                    style={{
                      width: '22%',
                      padding: screenSize >= 768 ? '18px 52px' : '12px 35px',
                      fontWeight: 700,
                      borderRadius: '2px',
                      backgroundColor: 'var(--white-color)',
                      color: 'var(--black-color)',
                      border: '1px solid var(--black-color)',
                      height: screenSize >= 768 ? 54 : 40,
                    }}
                    onClick={() => navigate(-1)}
                  >
                    취소
                  </Button>
                  <Button
                    type={'primary'}
                    style={{
                      width: '22%',
                      padding: screenSize >= 768 ? '18px 52px' : '12px 35px',
                      fontWeight: 700,
                      borderRadius: '2px',
                      height: screenSize >= 768 ? 54 : 40,
                    }}
                    onClick={() => onSubmit()}
                  >
                    저장
                  </Button>
                </Content>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MypageEditProfilePresenter;
